@import '../../../../constants/spacing.module.less';

.refresh-button {
  width: auto;
}

.ia-icon {
  padding: @space-4;
  height: 16px;
  width: 16px;

  color: var(--grey-800);
}

.input-column {
  flex: 3;
}
.button-column {
  flex: 1;
}

.error-message {
  color: var(--error--message--text-color--1);
  margin-top: @space-4;
}

.hs-description-text {
  padding: @space-8;
  background-color: var(--grey-100);
}

.hs-description-input-prefilled {
  background: var(--blue-fofoff-A50);
  input {
    border-color: var(--blue-600);
    color: var(--blue-600);
  }
}

.hs-tooltip-wrapper {
  height: 32px;
}
